// Pure step-resolution helpers for the onboarding wizard. Kept free of DOM and
// Stimulus so they can be unit-tested in isolation (see
// test/javascript/wizard_steps_test.js).

// Resolve the step to show on connect.
// serverHint: integer from data-onboarding-wizard-initial-step-value (0 when none)
// queryStep: raw string from URL ?step= (may be null/garbage)
// emailValid: boolean — prefilled kindle email passes validation
// Returns an integer 0..4.
export function resolveStep(serverHint, queryStep, emailValid) {
  // A positive server hint is a 422 re-render pointing at a specific step; it
  // bypasses clamping entirely.
  if (serverHint > 0) return serverHint

  const n = parseInt(queryStep, 10)
  if (Number.isNaN(n) || n < 0) return 0
  if (n <= 2) return n

  // Steps 3 and 4 require a valid prefilled email; otherwise fall back to the
  // last pre-email step. Anything beyond 4 clamps to the last reachable step.
  if (n <= 4) return emailValid ? n : 2
  return emailValid ? 4 : 2
}

// True when the trimmed, lowercased address ends in one of the Kindle domains
// and has a non-empty local part. Mirrors the server-side validation and the
// deleted onboarding_form_controller logic.
export function isValidKindleEmail(email, domains = ["kindle.com", "free.kindle.com", "kindle.cn"]) {
  if (!email) return false

  const value = email.trim().toLowerCase()
  if (!value) return false

  const domainPattern = domains.map((d) => d.replace(/\./g, "\\.")).join("|")
  return new RegExp(`^[a-z0-9._%+\\-]+@(${domainPattern})$`).test(value)
}
